export interface IQuoteSearchRequest {
  page: number
  pageSize: number
  patientFirstName?: string | undefined
  patientLastName?: string | undefined
  cptCode?: string | undefined
  providerGroup?: string | undefined
  insuranceCompany?: string | undefined
  primaryAdjuster?: string | undefined
  startDateFrom?: string | undefined
  startDateTo?: string | undefined
  quoteStatuses?: number[] | undefined
  quoteTypes?: number[] | undefined
  eocStatus?: string | undefined
  employer?: string | undefined
  notInvoiced: boolean
  eocNum?: string | undefined
  invoiced: boolean
  sorting?: { column: string; order: string } | undefined
  isConsumer: boolean
}

export class QuoteSearchRequest implements IQuoteSearchRequest {
  public page!: number
  public pageSize!: number
  public patientFirstName?: string | undefined
  public patientLastName?: string | undefined
  public cptCode?: string | undefined
  public providerGroup?: string | undefined
  public insuranceCompany?: string | undefined
  public primaryAdjuster?: string | undefined
  public startDateFrom?: string | undefined
  public startDateTo?: string | undefined
  public quoteStatuses?: number[] | undefined
  public quoteTypes?: number[] | undefined
  public eocStatus?: string | undefined
  public employer?: string | undefined
  public notInvoiced: boolean | false = false
  public eocNumber?: string | undefined
  public invoiced: boolean | false = false
  public sorting?: { column: string; order: string } | undefined
  public isConsumer: boolean | false = false
}
